import React from 'react';

function ProductStatCard({ statName, statValue }) {
    return (
        <div className='border border-[#EAEAEA] p-6 max-[1280px]:p-4 max-[1280px]:px-3 max-[1152px]:px-2 flex flex-col gap-1 max-[1152px]:gap-2 rounded-lg'>
            <h2 className='select-none font-semibold text-[14px] leading-[22px] max-[1200px]:text-sm max-[1024px]:text-xs text-[#666666]'>{statName}</h2>

            <h2 className='select-none font-semibold text-[20px] leading-8 max-[1152px]:text-base text-[#121212]'>{statValue}</h2>
        </div>
    )
}

export default ProductStatCard;
